import { computed } from '@angular/core';
import { OrderDto } from '@api/client';
import {
  patchState,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { OrderViewModel } from '../dashboard.interfaces';
import { getOrderNotifications, mapOrders } from './orders.utils';

export const useOrders = () =>
  signalStoreFeature(
    {
      props: {
        _notificationService: type<NotificationService>(),
      },
    },
    withState({
      orders: new Array<OrderDto>(),
    }),
    withComputed(store => {
      const orderViewModels = computed<OrderViewModel[]>(() =>
        store.orders().map(mapOrders),
      );

      return { orderViewModels };
    }),
    withMethods(store => {
      const setOrders = (orders: OrderDto[]) => {
        const notifications = getOrderNotifications(store.orders(), orders);

        patchState(store, { orders });

        notifications.forEach(({ message, params }) =>
          store._notificationService.showInfoNotification(message, params),
        );
      };

      return { setOrders };
    }),
  );
